import NotificationDropdown from 'components/layouts/navbar/top/NotificationDropdown';
import ProfileDropdown from 'components/layouts/navbar/top/ProfileDropdown';
import React from 'react';
import PropTypes from 'prop-types';
import { Tooltip } from 'components/common';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { FaCalendarAlt, FaInbox } from 'react-icons/fa';

// Shared style for icon links in the top-right nav (was falcon `.nav-link`)
const iconLinkClass =
  'ptl-tap tw-flex tw-items-center tw-px-2 tw-py-2 tw-text-base tw-text-[#5e6e82] hover:tw-text-[#232e3c] tw-no-underline tw-cursor-pointer tw-transition-colors';

// ── Calendar + Inbox quick-access icons ───────────────────────────────────────
const QuickNavIcon = ({ to, icon: Icon, tooltip, badge }) => (
  <li className="tw-list-none">
    <Tooltip content={tooltip} placement="bottom">
      <Link to={to} className={`${iconLinkClass} tw-relative`}>
        <Icon />
        {badge > 0 && (
          <span
            style={{
              position: 'absolute',
              top: 2,
              right: 2,
              minWidth: 16,
              height: 16,
              fontSize: 9,
              fontWeight: 700,
              lineHeight: '16px',
              textAlign: 'center',
              borderRadius: 8,
              padding: '0 3px',
              backgroundColor: '#e63757',
              color: '#fff',
              border: '1.5px solid #fff',
            }}
          >
            {badge > 99 ? '99+' : badge}
          </span>
        )}
      </Link>
    </Tooltip>
  </li>
);

QuickNavIcon.propTypes = {
  to: PropTypes.string.isRequired,
  icon: PropTypes.elementType.isRequired,
  tooltip: PropTypes.node,
  badge: PropTypes.number
};

const TopNavRightSideNavItem = () => {
  const inboxCount = useSelector(s => s.my_inbox?.unreadCount || 0);

  return (
    <ul className="tw-flex tw-flex-row tw-items-center tw-ml-auto tw-mb-0 tw-pl-0 tw-list-none">
      {/* My Calendar */}
      <QuickNavIcon to="/my/calendar" icon={FaCalendarAlt} tooltip="My Calendar" />

      {/* My Inbox — shows badge when emails exist */}
      <QuickNavIcon to="/my/inbox" icon={FaInbox} tooltip="My Inbox" badge={inboxCount} />

      <NotificationDropdown />

      <ProfileDropdown />
    </ul>
  );
};

export default TopNavRightSideNavItem;
